import APIManager from 'api/APIManager';
import APIConstant from 'api/APIConstant';
import { parameterToPath } from 'utils';

export type Event = {
  event_id?: number; // 이벤트 idx
  event_title?: string; // 이벤트 제목
  event_content?: string; // 이벤트 내용
  start_date?: number; // 시작일
  end_date?: number; // 종료일
  is_show?: string; // 노출 여부
  thumbnail_url?: string; //썸네일
  is_main?: string; //메인 이벤트 여부
  event_benefit?: string; // 혜택 요약
  created_at?: number; // 생성일
  updated_at?: number; // 수정일
};

const $http = new APIManager();

const Api = {
  /**
   * [GETS] Event
   * --
   */
  getEvents: async (params?: { [key: string]: string | number }) => {
    try {
      const res = await $http.get(APIConstant.GETS_EVENT, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [GET] Event
   * --
   */
  getEvent: async (
    idx: number,
    params?: { [key: string]: string | number }
  ) => {
    try {
      const url = parameterToPath(APIConstant.GET_EVENT, { event_id: idx });
      const res = await $http.get(url, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] Event
   * --
   */
  createEvent: async (body: Event) => {
    try {
      const res = await $http.post(APIConstant.CREATE_EVENT, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [PUT] Event
   * --
   */
  updateEvent: async (body: Event) => {
    try {
      const { event_id } = body;
      const url = parameterToPath(APIConstant.UPDATE_EVENT, {
        event_id: event_id,
      });

      const res = await $http.put(url, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [DELETE] Event
   * --
   */
  deleteEvent: async (idx: number) => {
    try {
      const url = parameterToPath(APIConstant.DELETE_EVENT, {
        event_id: idx,
      });

      const res = await $http.delete(url);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [PUT] Event
   * --
   */
  upsertEvent: async (body: Event[]) => {
    try {
      const res = await $http.bulk(APIConstant.BULK_UPSERT_EVENT, body, 'PUT');

      return res;
    } catch (e) {
      throw e;
    }
  },
};

export default Api;
